export const API_ENDPOINTS = {
  USER: {
    GET_ALL: "/users",
    // Add other customer-related endpoints
  },
  KYC: {
    CREATE: "/kyc",
    UPDATE: "/kyc",
    RETRY: "/retry_kyc",
    GET_KYC_DETAILS: "/kyc",
    GET_KYC_BY_USER_ID: "/kyc",
  },
  BANK: {
    CREATE: "/bank",
    UPDATE: "/bank",
    RETRY_VERIFICATION: "/retry_bank_verification",
    GET_BANK_DETAILS: "/bank",
    GET_BANK_BY_USER_ID: "/bank",
    
  },
  TRANSACTION: {
     CREATE: "/transaction",
    GET_ALL: "/transaction",
  },
  CUSTOMER: {
    GET_ALL: "/user",
    GET_CUSTOMER_BY_ID: "/user",
    // Add other customer-related endpoints
  },
  CLIENT:{
    PROFILE:"/client/profile"
  }
  // Add other endpoint categories
};



export const  kybData =
{
  "success": true,
  "message": "Kyb data fetched successfully",
    result: [
      {
          "kyb_id": "06a5de13-2ac6-4c8b-b9b6-0e5016230408",
          "client_id": "ab937578-6553-4c46-8148-553869e1d88f",
          "application_status": "auto_approved",
          "s3_selfie_image_url": "https://swiftramp.s3.ap-south-1.amazonaws.com/kyb-images/15b816c0-b8ad-4c11-b303-caaa1020e5a6.jpeg",
          "s3_pan_image_url": "https://swiftramp.s3.ap-south-1.amazonaws.com/kyb-images/7499d1fa-69c9-4781-bb33-47de6b603933.jpeg",
          "s3_aadhar_image_url": null,
          "metadata": {
              "results": [
                  {
                      "module": "",
                      "attempts": "1",
                      "apiResponse": {
                          "result": {
                              "response": "Variables synced to data source"
                          },
                          "status": "success",
                          "metadata": {
                              "requestId": "1754046356349-f4f6f193-20fb-4dd1-9951-ea5b03992c4b",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:05:57.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "GeoIP",
                      "attempts": "1",
                      "moduleId": "module_loEIac_ip_geolocation_api",
                      "apiResponse": {
                          "result": {
                              "summary": {
                                  "action": "pass",
                                  "details": []
                              },
                              "ipAddress": "203.145.56.249",
                              "geoDetails": {
                                  "as": "AS134375 Fusionnet Web Services Private Limited",
                                  "isp": "Fusionnet Web Services Private Limited",
                                  "lat": 28.5759,
                                  "lon": 77.3345,
                                  "org": "Parametrique Electronic Solutions Private Limited",
                                  "zip": "201301",
                                  "city": "Noida",
                                  "query": "203.145.56.249",
                                  "region": "UP",
                                  "status": "success",
                                  "country": "India",
                                  "timezone": "Asia/Kolkata",
                                  "regionName": "Uttar Pradesh",
                                  "countryCode": "IN"
                              }
                          },
                          "status": "success",
                          "metadata": {
                              "requestId": "1754046366645-cd363bbf-67cf-4772-ac70-d53f7233e23b",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:06:07.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "GSTIN API",
                      "attempts": "1",
                      "moduleId": "module_3DHrB9_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "turnOver": null,
                              "allFiling": [],
                              "hsnDetails": {
                                  "goods": [
                                      {
                                          "hsnCode": "85243111",
                                          "hsnDescription": "RECORDS, TAPES AND OTHER RECORDED MEDIA FOR SOUND OR OTHER SIMILARLY RECORDED PHENOMENA, INCLUDING MATRICES AND MASTERS FOR THE PRODUCTION OF RECORDS, BUT EXCLUDING PRODUCTS OF CHAPTER 37 - DISCS FOR LASER READING SYSTEMS: - FOR REPRODUCING PHENOMENA OTHER THAN SOUND OR IMAGE: - SOFTWARE: INFORMATION TECHNOLOGY SOFTWARE"
                                      },
                                      {
                                          "hsnCode": "85249112",
                                          "hsnDescription": "RECORDS, TAPES AND OTHER RECORDED MEDIA FOR SOUND OR OTHER SIMILARLY RECORDED PHENOMENA, INCLUDING MATRICES AND MASTERS FOR THE PRODUCTION OF RECORDS, BUT EXCLUDING PRODUCTS OF CHAPTER 37 - OTHER: - FOR REPRODUCING PHENOMENA OTHER THAN SOUND OR IMAGE: - SOFTWARE: INFORMATION TECHNOLOGY SOFTWARE ON DISC OR ON CD ROM"
                                      }
                                  ],
                                  "services": [
                                      {
                                          "hsnCode": "997331",
                                          "hsnDescription": "Licensing services for the right to use computer software and databases"
                                      },
                                      {
                                          "hsnCode": "998434",
                                          "hsnDescription": "Software downloads"
                                      },
                                      {
                                          "hsnCode": "997314",
                                          "hsnDescription": "Leasing or rental services concerning office machinery and equipment (except computers) without operator"
                                      }
                                  ]
                              },
                              "basicDetails": {
                                  "gstin": "09AAHCE1231H1ZW",
                                  "ekycFlag": "Not Applicable",
                                  "tradeName": "EOPSIN TECH PRIVATE LIMITED",
                                  "aggreTurnOver": "Slab: Rs. 0 to 40 lakhs",
                                  "memberDetails": [
                                      "Anup Kumar Gupta ",
                                      "Dipti Kumari "
                                  ],
                                  "businessNature": [
                                      "Factory / Manufacturing",
                                      "Supplier of Services",
                                      "Wholesale Business",
                                      "Retail Business"
                                  ],
                                  "aadhaarVerified": "Yes",
                                  "aggreTurnOverFY": "2024-2025",
                                  "compositionRate": "NA",
                                  "isEInvoiceOpted": "No",
                                  "cancellationDate": "",
                                  "percentTaxInCash": "Slab: 20% & above",
                                  "registrationDate": "30/01/2023",
                                  "registrationType": "Regular",
                                  "legalBusinessName": "EOPSIN TECH PRIVATE LIMITED",
                                  "stateJurisdiction": "State - Uttar Pradesh,Zone - Gautambudha Nagar,Range - Gautambudha Nagar(A),Sector - GautamBuddha Nagar Sector-9",
                                  "isEInvoiceMandated": "No",
                                  "percentTaxInCashFY": "2024-2025",
                                  "registrationStatus": "Active",
                                  "centralJurisdiction": "State - CBIC,Zone - MEERUT,Commissionerate - NOIDA,Division - DIVISION III NOIDA,Range - RANGE - 15 (Jurisdictional Office)",
                                  "constitutionOfBusiness": "Private Limited Company",
                                  "natureOfCoreBusinessActivity": "SPO"
                              },
                              "branchDetails": {
                                  "message": "",
                                  "principalAddress": {
                                      "address": "19TH FLOOR, TOWER A, UNIT NO. A-1919, SECTOR 75, Spectrum Metro Mall, Sector 62A, Noida, Gautambuddha Nagar, Uttar Pradesh, 201301",
                                      "natureOfBusiness": "Factory / Manufacturing, Supplier of Services, Wholesale Business, Retail Business"
                                  },
                                  "additionalAddresses": []
                              },
                              "filingDetails": {
                                  "filingStatus": [
                                      [
                                          {
                                              "finYear": "2025-2026",
                                              "returnType": "GSTR1",
                                              "dateOfFiling": "21/07/2025",
                                              "modeOfFiling": "ONLINE",
                                              "returnPeriod": "April"
                                          },
                                          {
                                              "finYear": "2025-2026",
                                              "returnType": "GSTR3B",
                                              "dateOfFiling": "21/07/2025",
                                              "modeOfFiling": "ONLINE",
                                              "returnPeriod": "April"
                                          }
                                      ]
                                  ]
                              },
                              "liabilityPaidDetails": {
                                  "currDetails": [
                                      {
                                          "period": "Apr-25",
                                          "liabPaidPct": 0
                                      }
                                  ],
                                  "currFinYear": "2025",
                                  "prevDetails": [
                                      {
                                          "period": "Apr-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "May-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Jun-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Jul-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Aug-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Sep-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Oct-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Nov-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Dec-24",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Jan-25",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Feb-25",
                                          "liabPaidPct": 0
                                      },
                                      {
                                          "period": "Mar-25",
                                          "liabPaidPct": 0
                                      }
                                  ],
                                  "prevFinYear": "2024",
                                  "prevTotalPct": null
                              }
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "1754046409229-d4486033-2db0-4eb5-91c6-a21c87796396",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:06:50.000Z",
                      "previousAttempts": []
                  },
                  {
                      "flag": {
                          "code": "503",
                          "message": "Source Unavailable"
                      },
                      "module": "CIN API",
                      "attempts": "1",
                      "moduleId": "module_LYqrsv_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "code": 200,
                              "data": {
                                  "charges": [],
                                  "company_master_data": {
                                      "cin": "U67100GJ2022PTC133462",
                                      "email_id": "eopsintech@gmail.com",
                                      "roc_code": "ROC Ahmedabad",
                                      "rd_region": "North Western Region",
                                      "company_name": "EOPSIN TECH PRIVATE LIMITED",
                                      "annual_returns": [
                                          {
                                              "@entity": "in.co.sandbox.kyc.mca.company.annual_return",
                                              "date_of_filing": "27/12/2024",
                                              "financial_year": "31/03/2024"
                                          },
                                          {
                                              "@entity": "in.co.sandbox.kyc.mca.company.annual_return",
                                              "date_of_filing": "23/12/2024",
                                              "financial_year": "31/03/2023"
                                          }
                                      ],
                                      "balance_sheets": [
                                          {
                                              "@entity": "in.co.sandbox.kyc.mca.company.balance_sheet",
                                              "date_of_filing": "27/12/2024",
                                              "financial_year": "31/03/2024"
                                          },
                                          {
                                              "@entity": "in.co.sandbox.kyc.mca.company.balance_sheet",
                                              "date_of_filing": "23/12/2024",
                                              "financial_year": "31/03/2023"
                                          }
                                      ],
                                      "total_director": 3,
                                      "class_of_company": "Private",
                                      "company_category": "Company limited by shares",
                                      "date_of_last_agm": "30/09/2024",
                                      "number_of_partners": "",
                                      "registered_address": "SHOP NO. 039, FIRST FLOOR,   JANADHAR MANGLA, GIFT CITY, PIROJPUR, Gandhinagar GANDHINAGAR Gujarat India 382355",
                                      "company_subcategory": "Non-government company",
                                      "paid_up_capital(rs)": "500000",
                                      "registration_number": "133462",
                                      "date_of_balance_sheet": "31/03/2024",
                                      "date_of_incorporation": "30/06/2022",
                                      "whether_listed_or_not": "Unlisted",
                                      "authorised_capital(rs)": "1000000",
                                      "company_status(for_efiling)": "Active",
                                      "suspended_at_stock_exchange": "-",
                                      "description_of_main_division": "Finance",
                                      "number_of_designated_partners": "",
                                      "total_obligation_of_contribution": "0",
                                      "previous_firm/_company_details,_if_applicable": "",
                                      "main_division_of_business_activity_to_be_carried_out_in_india": "67"
                                  },
                                  "directors/signatory_details": [
                                      {
                                          "name": "DIPTI KUMARI",
                                          "din/pan": "10118876",
                                          "end_date": "-",
                                          "begin_date": "30/09/2024",
                                          "designation": "Director"
                                      },
                                      {
                                          "name": "ASHISH KUMAR MISHRA",
                                          "din/pan": "08934476",
                                          "end_date": "-",
                                          "begin_date": "26/02/2025",
                                          "designation": "Managing Director"
                                      },
                                      {
                                          "name": "ANUP KUMAR GUPTA",
                                          "din/pan": "01641352",
                                          "end_date": "-",
                                          "begin_date": "30/09/2024",
                                          "designation": "Director"
                                      }
                                  ]
                              }
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "251b8027-04c9-47ff-b293-314b89c0d10d",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:07:24.000Z",
                      "previousAttempts": []
                  },
                  {
                      "attempts": "1",
                      "moduleId": "module_TZQlCo_text_match_module_lib_module_fieldmatch_text_match_api",
                      "apiResponse": {
                          "result": {
                              "all": true,
                              "name": true,
                              "summary": {
                                  "action": "pass",
                                  "details": []
                              }
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:07:25.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Fetch Director Details API",
                      "attempts": "1",
                      "moduleId": "module_W2S2LS_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "code": 200,
                              "data": {
                                  "llp_data": [
                                      {
                                          "end_date": "-",
                                          "llp_name": "VELES STRATAGEM LLP",
                                          "begin_date": "10-04-2025",
                                          "designation": "Designated Partner",
                                          "llpin/fllpin": "ACC-8731"
                                      }
                                  ],
                                  "company_data": [
                                      {
                                          "cin/fcrn": "U67100GJ2022PTC133462",
                                          "end_date": "-",
                                          "begin_date": "19-04-2023",
                                          "designation": "Director",
                                          "company_name": "EOPSIN TECH PRIVATE LIMITED"
                                      },
                                      {
                                          "cin/fcrn": "U67100GJ2022PTC133462",
                                          "end_date": "29-09-2024",
                                          "begin_date": "19-04-2023",
                                          "designation": "Additional Director",
                                          "company_name": "EOPSIN TECH PRIVATE LIMITED"
                                      }
                                  ],
                                  "director_data": {
                                      "din": "10118876",
                                      "name": "DIPTI KUMARI"
                                  }
                              },
                              "timestamp": 1754046462359
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:07:46.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Selfie Validation",
                      "attempts": "1",
                      "imageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/checkLiveness/2025-08-01/4uy459/1754046536141-e0335dd1-d391-408f-a481-301352f56d00/image.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZRKK5ZMRXJAJLUSL%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111357Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAk%2FfI8s5TWLBI3iN1IZVqeDYjSg5O16HzFXarA4fZ9HkCICVLS5RQnYRO%2BriZ%2Fh7wu0KYvWy9c%2BHILAHEqTU24AUjKsgFCOn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQARoMNjU1Njc2NTI1MzQ3Igzhc0f38sqWHVhmW6EqnAVzwPNNWxTB8RMl%2BC8zz2c8hhOSb2ZD1LATIgJM5BFx%2BSxPjt%2FmbUdklWgMG7SPlYiHlj514SqG%2F55qtTCglfWJ2L27t2HUmBo6A8ufWOL0F2l%2BhWOBfy%2FpEg%2BBLKVYSl135wMe3zVDFLShA%2BhgzA%2BN31%2F2Ji9IzOrm9FKYwbJtp%2BXgDaekpCDnMk0FZ%2BE7Q49%2F4VADFIAxDJ31V1V38wQa9k7D673LWDlCjA2V5k9St32xQFXeklpX98k%2F42H1ByH5MColef2vxG9xuJZFKxvXJG%2FML9L4SDY6%2BE3Ij053W%2BA4McrdjOl3Lg5%2FD33WlzhAeHJANdcwrLxKpCUjYjqNmrOUOUOmwfCBj55xHys6Hq2XophXjDQFJB2jxRIkFgrFIg1E4w%2BI40Uk7x%2BO01QHNHGqJWu90tgW1Vek1f8dGKciOCpSJS6NKMuz%2FaPjZyv9IAboY9gsQaXDuaujaadjuegG8kXQ57KWQVNMBPe%2BDfFGHD9AaJSNGZPY%2FeK0ELUTmqgpZaOCvTZKkh0kLBCb%2FTIi3QQJFNQd5TZv%2BONxyDW5fTy2Ck2%2BNmYpWM%2FZUpEZE8xdDcc%2FSxcKcDbLsHztsojHj1GtBjKeIDojRXT3SAsJRlFQE%2BgUT5aMmuAC7bxEHKqRpa6btwGl1EwMaucP5pGWd0XIs2D0vRVGg8SCwy1k8sQhzIBVjSA82LF8XKjV1QV2kw41icMHwsbzaezKZ6QCVdVDVoKl2xfWwteV9wb9mc0tUBJv8ubvzZtnqaDeOzdedTvNW9iL84A6wjQI%2FYtk2lxvQi9TC7KrSEPqxxT32WvwZsYpXMRF3%2BM1LLEjYHNTW1631MC5dczzw4V5Gl8TCWZHOUV0FQdDPG4nCsGCNIpnVG7qKbZ3izDE77HEBjqxAc0j%2BRFj2eC2ViT5alj%2BsudElPY1vZqIb5IHRdjBjnrO7saroZ5hiGI%2B8pOtEs2FDblDPjudsovbZM4E8tqkvKuqhqIRS3yVsAJOR8%2B%2B9CSH%2F6PUZQYdVY%2BtXWNH5x7egCfTaw2Y%2BcPRXcyIwCul66ISQGpCLpN2LLEsaNLfYwgEEuX%2Bg1e6jpYzHeTw79L806kgPxzQl2XaCHSK%2FblLZH2OH4ALTN7co5gnvBb5J2X4Rg%3D%3D&X-Amz-Signature=6c90e217fecf90fff19b1f1baa5a2b8fd9839a745ecddf6889a0bd1f0927bfa5&X-Amz-SignedHeaders=host",
                      "moduleId": "module_dbV1uU_selfie_validation",
                      "apiResponse": {
                          "result": {
                              "details": {
                                  "liveFace": {
                                      "score": 98,
                                      "value": "yes",
                                      "confidence": "high"
                                  }
                              },
                              "summary": {
                                  "action": "pass",
                                  "details": []
                              },
                              "inputImageUrls": {
                                  "image": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/checkLiveness/2025-08-01/4uy459/1754046536141-e0335dd1-d391-408f-a481-301352f56d00/image.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXB3KY4F5AOPLQAKK%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T110856Z&X-Amz-Expires=10800&X-Amz-Signature=0925d753ba1ed0a765c727956a7874f2ad953debf72ddb99fd57d504c7b86ecf&X-Amz-SignedHeaders=host"
                              }
                          },
                          "status": "success",
                          "metadata": {
                              "requestId": "1754046536141-e0335dd1-d391-408f-a481-301352f56d00",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:08:57.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "PAN Capture for Individual front",
                      "attempts": "1",
                      "imageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/readId/2025-08-01/4uy459/1754046551516-b1afc3d0-dc7b-41da-b0e6-168a89c393bb/image.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZRKK5ZMRXJAJLUSL%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111357Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAk%2FfI8s5TWLBI3iN1IZVqeDYjSg5O16HzFXarA4fZ9HkCICVLS5RQnYRO%2BriZ%2Fh7wu0KYvWy9c%2BHILAHEqTU24AUjKsgFCOn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQARoMNjU1Njc2NTI1MzQ3Igzhc0f38sqWHVhmW6EqnAVzwPNNWxTB8RMl%2BC8zz2c8hhOSb2ZD1LATIgJM5BFx%2BSxPjt%2FmbUdklWgMG7SPlYiHlj514SqG%2F55qtTCglfWJ2L27t2HUmBo6A8ufWOL0F2l%2BhWOBfy%2FpEg%2BBLKVYSl135wMe3zVDFLShA%2BhgzA%2BN31%2F2Ji9IzOrm9FKYwbJtp%2BXgDaekpCDnMk0FZ%2BE7Q49%2F4VADFIAxDJ31V1V38wQa9k7D673LWDlCjA2V5k9St32xQFXeklpX98k%2F42H1ByH5MColef2vxG9xuJZFKxvXJG%2FML9L4SDY6%2BE3Ij053W%2BA4McrdjOl3Lg5%2FD33WlzhAeHJANdcwrLxKpCUjYjqNmrOUOUOmwfCBj55xHys6Hq2XophXjDQFJB2jxRIkFgrFIg1E4w%2BI40Uk7x%2BO01QHNHGqJWu90tgW1Vek1f8dGKciOCpSJS6NKMuz%2FaPjZyv9IAboY9gsQaXDuaujaadjuegG8kXQ57KWQVNMBPe%2BDfFGHD9AaJSNGZPY%2FeK0ELUTmqgpZaOCvTZKkh0kLBCb%2FTIi3QQJFNQd5TZv%2BONxyDW5fTy2Ck2%2BNmYpWM%2FZUpEZE8xdDcc%2FSxcKcDbLsHztsojHj1GtBjKeIDojRXT3SAsJRlFQE%2BgUT5aMmuAC7bxEHKqRpa6btwGl1EwMaucP5pGWd0XIs2D0vRVGg8SCwy1k8sQhzIBVjSA82LF8XKjV1QV2kw41icMHwsbzaezKZ6QCVdVDVoKl2xfWwteV9wb9mc0tUBJv8ubvzZtnqaDeOzdedTvNW9iL84A6wjQI%2FYtk2lxvQi9TC7KrSEPqxxT32WvwZsYpXMRF3%2BM1LLEjYHNTW1631MC5dczzw4V5Gl8TCWZHOUV0FQdDPG4nCsGCNIpnVG7qKbZ3izDE77HEBjqxAc0j%2BRFj2eC2ViT5alj%2BsudElPY1vZqIb5IHRdjBjnrO7saroZ5hiGI%2B8pOtEs2FDblDPjudsovbZM4E8tqkvKuqhqIRS3yVsAJOR8%2B%2B9CSH%2F6PUZQYdVY%2BtXWNH5x7egCfTaw2Y%2BcPRXcyIwCul66ISQGpCLpN2LLEsaNLfYwgEEuX%2Bg1e6jpYzHeTw79L806kgPxzQl2XaCHSK%2FblLZH2OH4ALTN7co5gnvBb5J2X4Rg%3D%3D&X-Amz-Signature=d3a5d067b9b9fd9ece53742f110f90b0494a2506d282b0522b90099fe8fc7212&X-Amz-SignedHeaders=host",
                      "moduleId": "module_QEYdQ0_id_card_validation",
                      "apiResponse": {
                          "result": {
                              "details": [
                                  {
                                      "idType": "pan",
                                      "ruleChecks": {
                                          "invalidDateOfExpiry": {
                                              "value": "not_applicable"
                                          }
                                      },
                                      "croppedImageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/readId/2025-08-01/4uy459/1754046551516-b1afc3d0-dc7b-41da-b0e6-168a89c393bb/cropped.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXB3KY4F5AOPLQAKK%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T110912Z&X-Amz-Expires=10800&X-Amz-Signature=98910e842fdd33cf9897f218d1faa5d18c610f2e9ca6c255c343d5a88297eaf5&X-Amz-SignedHeaders=host",
                                      "fieldsExtracted": {
                                          "age": {
                                              "value": ""
                                          },
                                          "type": {
                                              "value": ""
                                          },
                                          "gender": {
                                              "value": ""
                                          },
                                          "address": {
                                              "value": "",
                                              "street": "",
                                              "zipCode": "",
                                              "district": "",
                                              "province": "",
                                              "houseNumber": "",
                                              "additionalInfo": ""
                                          },
                                          "fullName": {
                                              "value": "DIPUMA RI"
                                          },
                                          "homeTown": {
                                              "value": ""
                                          },
                                          "idNumber": {
                                              "value": "MQCPK0294A"
                                          },
                                          "lastName": {
                                              "value": ""
                                          },
                                          "firstName": {
                                              "value": ""
                                          },
                                          "mrzString": {
                                              "value": "",
                                              "gender": "",
                                              "fullName": "",
                                              "idNumber": "",
                                              "dateOfBirth": "",
                                              "nationality": "",
                                              "dateOfExpiry": ""
                                          },
                                          "fatherName": {
                                              "value": "MANOJ KUMAR RA"
                                          },
                                          "middleName": {
                                              "value": ""
                                          },
                                          "motherName": {
                                              "value": ""
                                          },
                                          "spouseName": {
                                              "value": ""
                                          },
                                          "countryCode": {
                                              "value": ""
                                          },
                                          "dateOfBirth": {
                                              "value": ""
                                          },
                                          "dateOfIssue": {
                                              "value": ""
                                          },
                                          "husbandName": {
                                              "value": ""
                                          },
                                          "nationality": {
                                              "value": ""
                                          },
                                          "yearOfBirth": {
                                              "value": "2064"
                                          },
                                          "dateOfExpiry": {
                                              "value": ""
                                          },
                                          "placeOfBirth": {
                                              "value": ""
                                          },
                                          "placeOfIssue": {
                                              "value": ""
                                          }
                                      }
                                  }
                              ],
                              "summary": {
                                  "action": "pass",
                                  "details": []
                              },
                              "inputImageUrls": {
                                  "image": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/readId/2025-08-01/4uy459/1754046551516-b1afc3d0-dc7b-41da-b0e6-168a89c393bb/image.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXB3KY4F5AOPLQAKK%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T110912Z&X-Amz-Expires=10800&X-Amz-Signature=b326c97e6a5da342b5ff5e6b14a488e6514e7971f6fd99a26a840fb753115a21&X-Amz-SignedHeaders=host"
                              }
                          },
                          "status": "success",
                          "metadata": {
                              "requestId": "1754046551516-b1afc3d0-dc7b-41da-b0e6-168a89c393bb",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:09:13.000Z",
                      "countrySelected": "ind",
                      "croppedImageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/readId/2025-08-01/4uy459/1754046551516-b1afc3d0-dc7b-41da-b0e6-168a89c393bb/cropped.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZRKK5ZMRXJAJLUSL%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111357Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAk%2FfI8s5TWLBI3iN1IZVqeDYjSg5O16HzFXarA4fZ9HkCICVLS5RQnYRO%2BriZ%2Fh7wu0KYvWy9c%2BHILAHEqTU24AUjKsgFCOn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQARoMNjU1Njc2NTI1MzQ3Igzhc0f38sqWHVhmW6EqnAVzwPNNWxTB8RMl%2BC8zz2c8hhOSb2ZD1LATIgJM5BFx%2BSxPjt%2FmbUdklWgMG7SPlYiHlj514SqG%2F55qtTCglfWJ2L27t2HUmBo6A8ufWOL0F2l%2BhWOBfy%2FpEg%2BBLKVYSl135wMe3zVDFLShA%2BhgzA%2BN31%2F2Ji9IzOrm9FKYwbJtp%2BXgDaekpCDnMk0FZ%2BE7Q49%2F4VADFIAxDJ31V1V38wQa9k7D673LWDlCjA2V5k9St32xQFXeklpX98k%2F42H1ByH5MColef2vxG9xuJZFKxvXJG%2FML9L4SDY6%2BE3Ij053W%2BA4McrdjOl3Lg5%2FD33WlzhAeHJANdcwrLxKpCUjYjqNmrOUOUOmwfCBj55xHys6Hq2XophXjDQFJB2jxRIkFgrFIg1E4w%2BI40Uk7x%2BO01QHNHGqJWu90tgW1Vek1f8dGKciOCpSJS6NKMuz%2FaPjZyv9IAboY9gsQaXDuaujaadjuegG8kXQ57KWQVNMBPe%2BDfFGHD9AaJSNGZPY%2FeK0ELUTmqgpZaOCvTZKkh0kLBCb%2FTIi3QQJFNQd5TZv%2BONxyDW5fTy2Ck2%2BNmYpWM%2FZUpEZE8xdDcc%2FSxcKcDbLsHztsojHj1GtBjKeIDojRXT3SAsJRlFQE%2BgUT5aMmuAC7bxEHKqRpa6btwGl1EwMaucP5pGWd0XIs2D0vRVGg8SCwy1k8sQhzIBVjSA82LF8XKjV1QV2kw41icMHwsbzaezKZ6QCVdVDVoKl2xfWwteV9wb9mc0tUBJv8ubvzZtnqaDeOzdedTvNW9iL84A6wjQI%2FYtk2lxvQi9TC7KrSEPqxxT32WvwZsYpXMRF3%2BM1LLEjYHNTW1631MC5dczzw4V5Gl8TCWZHOUV0FQdDPG4nCsGCNIpnVG7qKbZ3izDE77HEBjqxAc0j%2BRFj2eC2ViT5alj%2BsudElPY1vZqIb5IHRdjBjnrO7saroZ5hiGI%2B8pOtEs2FDblDPjudsovbZM4E8tqkvKuqhqIRS3yVsAJOR8%2B%2B9CSH%2F6PUZQYdVY%2BtXWNH5x7egCfTaw2Y%2BcPRXcyIwCul66ISQGpCLpN2LLEsaNLfYwgEEuX%2Bg1e6jpYzHeTw79L806kgPxzQl2XaCHSK%2FblLZH2OH4ALTN7co5gnvBb5J2X4Rg%3D%3D&X-Amz-Signature=eac1c236f59a09100746de121fbb300ea50798e07645bd829bcf8c16c1ba7281&X-Amz-SignedHeaders=host",
                      "documentSelected": "pan",
                      "previousAttempts": [],
                      "expectedDocumentSide": "front"
                  },
                  {
                      "module": "Health Check Digilocker API",
                      "attempts": "1",
                      "moduleId": "module_hFWzdF_digilocker_lib_module_health_check_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "status": "PARTIALLY_AVAILABLE",
                              "message": "DigiLocker service is partially available: startApiErrorRate=0.0000, tokenApiRatio=0.5475, eAadhaarApiRatio=0.4905",
                              "metrics": {
                                  "checks": {
                                      "tokenApiRatioCheck": "WARNING",
                                      "startApiFailureCheck": "PASSED",
                                      "eAadhaarApiRatioCheck": "PASSED"
                                  },
                                  "thresholds": {
                                      "unhealthy": {
                                          "tokenApiRatio": 0.28,
                                          "eAadhaarApiRatio": 0.16,
                                          "startApiErrorRatio": 0.1
                                      },
                                      "partiallyAvailable": {
                                          "tokenApiRatio": 0.6,
                                          "eAadhaarApiRatio": 0.27,
                                          "startApiErrorRatio": 0.05
                                      }
                                  },
                                  "startApiTotal": 579,
                                  "tokenApiRatio": "54.75%",
                                  "eAadhaarApiRatio": "49.05%",
                                  "startApiFailureRate": "0.00%"
                              },
                              "endpoint": "/api/digilocker/status",
                              "isHealthy": true,
                              "isPartiallyAvailable": true
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:09:14.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Generate Reference ID",
                      "attempts": "1",
                      "moduleId": "module_hFWzdF_digilocker_generate_reference_id_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "refrenceId": "e591a930-bf61-4743-b06c-058b583e30b5_1754046557398"
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "1754046557273-56204568-b889-4a7e-a512-21839a055112",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:09:18.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Start DigiLocker API",
                      "attempts": "1",
                      "moduleId": "module_hFWzdF_digilocker_start_digilocker_api_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "url": "https://api.digitallocker.gov.in/public/oauth2/1/authorize?client_id=D374178C&state=e591a930-bf61-4743-b06c-058b583e30b5_1754046557398,https://app.idv.hyperverge.co/generic/redirect,mdsq1760,4uy459,no,,,ab937578-6553-4c46-8148-553869e1d88f,yes&response_type=code&dl_flow=signup"
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:09:20.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "",
                      "attempts": "1",
                      "apiResponse": {
                          "result": {
                              "status": "success"
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:11:37.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Eaadhaar Digilocker API",
                      "attempts": "1",
                      "moduleId": "module_hFWzdF_digilocker_lib_module_aadhaar_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "dob": "06-03-2004",
                              "name": "Dipti Kumari",
                              "photo": "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",
                              "gender": "F",
                              "address": " D/O: Manoj Kumar Rai,, India, East Delhi, House no-B-378, Gali no-2 Rajveer colony, 110096, Mayur Vihar Ph-III , Delhi, Aatri bhawan, Preet Vihar, Gharoli",
                              "aadhaarFile": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/india-verify/eAadhaarDetails/2025-08-01/4uy459/1754046697157-1267e5a4-bcb5-4ec0-8ded-cf57a48ff943/eAadhaar.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXB3KY4F5MSJLVHU6%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111138Z&X-Amz-Expires=10800&X-Amz-Signature=d2f7fd4d81a6d5ac147bc1b30640793dbe44646e512b0ca4d6e50f39a641329e&X-Amz-SignedHeaders=host",
                              "addressFields": {
                                  "co": "D/O: Manoj Kumar Rai",
                                  "vtc": "Gharoli",
                                  "house": "House no-B-378",
                                  "state": "Delhi",
                                  "street": "Aatri bhawan",
                                  "country": "India",
                                  "pincode": "110096",
                                  "district": "East Delhi",
                                  "landmark": "",
                                  "locality": "Gali no-2 Rajveer colony",
                                  "postOffice": "Mayur Vihar Ph-III ",
                                  "subDistrict": "Preet Vihar"
                              },
                              "xmlAadhaarFile": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/india-verify/eAadhaarDetails/2025-08-01/4uy459/1754046697157-1267e5a4-bcb5-4ec0-8ded-cf57a48ff943/aadhaarXml.xml?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXB3KY4F5MSJLVHU6%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111138Z&X-Amz-Expires=10800&X-Amz-Signature=9f2185e86994e4c8e24a98bd1f9de2c31377e16c35be1cad7fb85a9e1d8858c9&X-Amz-SignedHeaders=host",
                              "createdTimeStamp": 1754046698462,
                              "maskedAadhaarNumber": "xxxxxxxx4317"
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:11:39.000Z",
                      "eaadhaarImageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/india-verify/eAadhaarDetails/2025-08-01/4uy459/1754046697157-1267e5a4-bcb5-4ec0-8ded-cf57a48ff943/eAadhaar.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZRKK5ZMRXJAJLUSL%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111357Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAk%2FfI8s5TWLBI3iN1IZVqeDYjSg5O16HzFXarA4fZ9HkCICVLS5RQnYRO%2BriZ%2Fh7wu0KYvWy9c%2BHILAHEqTU24AUjKsgFCOn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQARoMNjU1Njc2NTI1MzQ3Igzhc0f38sqWHVhmW6EqnAVzwPNNWxTB8RMl%2BC8zz2c8hhOSb2ZD1LATIgJM5BFx%2BSxPjt%2FmbUdklWgMG7SPlYiHlj514SqG%2F55qtTCglfWJ2L27t2HUmBo6A8ufWOL0F2l%2BhWOBfy%2FpEg%2BBLKVYSl135wMe3zVDFLShA%2BhgzA%2BN31%2F2Ji9IzOrm9FKYwbJtp%2BXgDaekpCDnMk0FZ%2BE7Q49%2F4VADFIAxDJ31V1V38wQa9k7D673LWDlCjA2V5k9St32xQFXeklpX98k%2F42H1ByH5MColef2vxG9xuJZFKxvXJG%2FML9L4SDY6%2BE3Ij053W%2BA4McrdjOl3Lg5%2FD33WlzhAeHJANdcwrLxKpCUjYjqNmrOUOUOmwfCBj55xHys6Hq2XophXjDQFJB2jxRIkFgrFIg1E4w%2BI40Uk7x%2BO01QHNHGqJWu90tgW1Vek1f8dGKciOCpSJS6NKMuz%2FaPjZyv9IAboY9gsQaXDuaujaadjuegG8kXQ57KWQVNMBPe%2BDfFGHD9AaJSNGZPY%2FeK0ELUTmqgpZaOCvTZKkh0kLBCb%2FTIi3QQJFNQd5TZv%2BONxyDW5fTy2Ck2%2BNmYpWM%2FZUpEZE8xdDcc%2FSxcKcDbLsHztsojHj1GtBjKeIDojRXT3SAsJRlFQE%2BgUT5aMmuAC7bxEHKqRpa6btwGl1EwMaucP5pGWd0XIs2D0vRVGg8SCwy1k8sQhzIBVjSA82LF8XKjV1QV2kw41icMHwsbzaezKZ6QCVdVDVoKl2xfWwteV9wb9mc0tUBJv8ubvzZtnqaDeOzdedTvNW9iL84A6wjQI%2FYtk2lxvQi9TC7KrSEPqxxT32WvwZsYpXMRF3%2BM1LLEjYHNTW1631MC5dczzw4V5Gl8TCWZHOUV0FQdDPG4nCsGCNIpnVG7qKbZ3izDE77HEBjqxAc0j%2BRFj2eC2ViT5alj%2BsudElPY1vZqIb5IHRdjBjnrO7saroZ5hiGI%2B8pOtEs2FDblDPjudsovbZM4E8tqkvKuqhqIRS3yVsAJOR8%2B%2B9CSH%2F6PUZQYdVY%2BtXWNH5x7egCfTaw2Y%2BcPRXcyIwCul66ISQGpCLpN2LLEsaNLfYwgEEuX%2Bg1e6jpYzHeTw79L806kgPxzQl2XaCHSK%2FblLZH2OH4ALTN7co5gnvBb5J2X4Rg%3D%3D&X-Amz-Signature=b46985bdf616144688df10736c9dc8eb5f1a6a85ac3667ee6dcbc1861082418f&X-Amz-SignedHeaders=host",
                      "previousAttempts": [],
                      "aadhaarxmlImageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/india-verify/eAadhaarDetails/2025-08-01/4uy459/1754046697157-1267e5a4-bcb5-4ec0-8ded-cf57a48ff943/aadhaarXml.xml?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZRKK5ZMRXJAJLUSL%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111357Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAk%2FfI8s5TWLBI3iN1IZVqeDYjSg5O16HzFXarA4fZ9HkCICVLS5RQnYRO%2BriZ%2Fh7wu0KYvWy9c%2BHILAHEqTU24AUjKsgFCOn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQARoMNjU1Njc2NTI1MzQ3Igzhc0f38sqWHVhmW6EqnAVzwPNNWxTB8RMl%2BC8zz2c8hhOSb2ZD1LATIgJM5BFx%2BSxPjt%2FmbUdklWgMG7SPlYiHlj514SqG%2F55qtTCglfWJ2L27t2HUmBo6A8ufWOL0F2l%2BhWOBfy%2FpEg%2BBLKVYSl135wMe3zVDFLShA%2BhgzA%2BN31%2F2Ji9IzOrm9FKYwbJtp%2BXgDaekpCDnMk0FZ%2BE7Q49%2F4VADFIAxDJ31V1V38wQa9k7D673LWDlCjA2V5k9St32xQFXeklpX98k%2F42H1ByH5MColef2vxG9xuJZFKxvXJG%2FML9L4SDY6%2BE3Ij053W%2BA4McrdjOl3Lg5%2FD33WlzhAeHJANdcwrLxKpCUjYjqNmrOUOUOmwfCBj55xHys6Hq2XophXjDQFJB2jxRIkFgrFIg1E4w%2BI40Uk7x%2BO01QHNHGqJWu90tgW1Vek1f8dGKciOCpSJS6NKMuz%2FaPjZyv9IAboY9gsQaXDuaujaadjuegG8kXQ57KWQVNMBPe%2BDfFGHD9AaJSNGZPY%2FeK0ELUTmqgpZaOCvTZKkh0kLBCb%2FTIi3QQJFNQd5TZv%2BONxyDW5fTy2Ck2%2BNmYpWM%2FZUpEZE8xdDcc%2FSxcKcDbLsHztsojHj1GtBjKeIDojRXT3SAsJRlFQE%2BgUT5aMmuAC7bxEHKqRpa6btwGl1EwMaucP5pGWd0XIs2D0vRVGg8SCwy1k8sQhzIBVjSA82LF8XKjV1QV2kw41icMHwsbzaezKZ6QCVdVDVoKl2xfWwteV9wb9mc0tUBJv8ubvzZtnqaDeOzdedTvNW9iL84A6wjQI%2FYtk2lxvQi9TC7KrSEPqxxT32WvwZsYpXMRF3%2BM1LLEjYHNTW1631MC5dczzw4V5Gl8TCWZHOUV0FQdDPG4nCsGCNIpnVG7qKbZ3izDE77HEBjqxAc0j%2BRFj2eC2ViT5alj%2BsudElPY1vZqIb5IHRdjBjnrO7saroZ5hiGI%2B8pOtEs2FDblDPjudsovbZM4E8tqkvKuqhqIRS3yVsAJOR8%2B%2B9CSH%2F6PUZQYdVY%2BtXWNH5x7egCfTaw2Y%2BcPRXcyIwCul66ISQGpCLpN2LLEsaNLfYwgEEuX%2Bg1e6jpYzHeTw79L806kgPxzQl2XaCHSK%2FblLZH2OH4ALTN7co5gnvBb5J2X4Rg%3D%3D&X-Amz-Signature=8b339eab0c5cd0708dfab84843bf6d45e59fa65cb085f432ea303492a0fb703c&X-Amz-SignedHeaders=host"
                  },
                  {
                      "module": "Face Match",
                      "attempts": "1",
                      "moduleId": "module_e9rHHO_face_match_supermodule_lib_face_match_api_face_match_v2",
                      "apiResponse": {
                          "result": {
                              "details": {
                                  "match": {
                                      "score": 95,
                                      "value": "yes",
                                      "confidence": "high"
                                  }
                              },
                              "summary": {
                                  "action": "pass",
                                  "details": []
                              },
                              "inputImageUrls": {
                                  "selfie": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/matchFace/2025-08-01/4uy459/1754046701039-d39fb466-646d-425e-a7e2-0fdc37f804bb/selfie.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXB3KY4F5AOPLQAKK%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111141Z&X-Amz-Expires=10800&X-Amz-Signature=808409c7cdef721a47b4d700b0f1a14e8b0930e6b8db13694baed4cb734bd90e&X-Amz-SignedHeaders=host"
                              }
                          },
                          "status": "success",
                          "metadata": {
                              "requestId": "1754046701039-d39fb466-646d-425e-a7e2-0fdc37f804bb",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:11:42.000Z",
                      "selfieImageUrl": "https://prod-audit-portal-ind.s3.ap-south-1.amazonaws.com/gkyc-ap-south-1/matchFace/2025-08-01/4uy459/1754046701039-d39fb466-646d-425e-a7e2-0fdc37f804bb/selfie.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZRKK5ZMRXJAJLUSL%2F20250801%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250801T111357Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEMD%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEAk%2FfI8s5TWLBI3iN1IZVqeDYjSg5O16HzFXarA4fZ9HkCICVLS5RQnYRO%2BriZ%2Fh7wu0KYvWy9c%2BHILAHEqTU24AUjKsgFCOn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQARoMNjU1Njc2NTI1MzQ3Igzhc0f38sqWHVhmW6EqnAVzwPNNWxTB8RMl%2BC8zz2c8hhOSb2ZD1LATIgJM5BFx%2BSxPjt%2FmbUdklWgMG7SPlYiHlj514SqG%2F55qtTCglfWJ2L27t2HUmBo6A8ufWOL0F2l%2BhWOBfy%2FpEg%2BBLKVYSl135wMe3zVDFLShA%2BhgzA%2BN31%2F2Ji9IzOrm9FKYwbJtp%2BXgDaekpCDnMk0FZ%2BE7Q49%2F4VADFIAxDJ31V1V38wQa9k7D673LWDlCjA2V5k9St32xQFXeklpX98k%2F42H1ByH5MColef2vxG9xuJZFKxvXJG%2FML9L4SDY6%2BE3Ij053W%2BA4McrdjOl3Lg5%2FD33WlzhAeHJANdcwrLxKpCUjYjqNmrOUOUOmwfCBj55xHys6Hq2XophXjDQFJB2jxRIkFgrFIg1E4w%2BI40Uk7x%2BO01QHNHGqJWu90tgW1Vek1f8dGKciOCpSJS6NKMuz%2FaPjZyv9IAboY9gsQaXDuaujaadjuegG8kXQ57KWQVNMBPe%2BDfFGHD9AaJSNGZPY%2FeK0ELUTmqgpZaOCvTZKkh0kLBCb%2FTIi3QQJFNQd5TZv%2BONxyDW5fTy2Ck2%2BNmYpWM%2FZUpEZE8xdDcc%2FSxcKcDbLsHztsojHj1GtBjKeIDojRXT3SAsJRlFQE%2BgUT5aMmuAC7bxEHKqRpa6btwGl1EwMaucP5pGWd0XIs2D0vRVGg8SCwy1k8sQhzIBVjSA82LF8XKjV1QV2kw41icMHwsbzaezKZ6QCVdVDVoKl2xfWwteV9wb9mc0tUBJv8ubvzZtnqaDeOzdedTvNW9iL84A6wjQI%2FYtk2lxvQi9TC7KrSEPqxxT32WvwZsYpXMRF3%2BM1LLEjYHNTW1631MC5dczzw4V5Gl8TCWZHOUV0FQdDPG4nCsGCNIpnVG7qKbZ3izDE77HEBjqxAc0j%2BRFj2eC2ViT5alj%2BsudElPY1vZqIb5IHRdjBjnrO7saroZ5hiGI%2B8pOtEs2FDblDPjudsovbZM4E8tqkvKuqhqIRS3yVsAJOR8%2B%2B9CSH%2F6PUZQYdVY%2BtXWNH5x7egCfTaw2Y%2BcPRXcyIwCul66ISQGpCLpN2LLEsaNLfYwgEEuX%2Bg1e6jpYzHeTw79L806kgPxzQl2XaCHSK%2FblLZH2OH4ALTN7co5gnvBb5J2X4Rg%3D%3D&X-Amz-Signature=083b25ec61e9ccca00111e80ff59d2ddb50e93f87f92b98bbe9c3f23041fc3a1&X-Amz-SignedHeaders=host",
                      "previousAttempts": []
                  },
                  {
                      "attempts": "1",
                      "moduleId": "module_SVKCDM_text_match_module_lib_module_fieldmatch_text_match_api",
                      "apiResponse": {
                          "result": {
                              "all": true,
                              "name": true,
                              "summary": {
                                  "action": "pass",
                                  "details": []
                              }
                          },
                          "status": "success",
                          "statusCode": "200"
                      },
                      "processedAt": "2025-08-01T11:11:43.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "AML",
                      "attempts": "1",
                      "moduleId": "module_pbrhPI_aml_search_api",
                      "apiResponse": {
                          "result": {
                              "hits": []
                          },
                          "summary": {
                              "action": "pass",
                              "details": []
                          },
                          "metaData": {
                              "requestId": "1754046702891-cd2cf742-21df-4002-9f78-c1fe532ba541",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:11:45.000Z",
                      "countrySelected": "ind",
                      "previousAttempts": []
                  },
                  {
                      "module": "Pennyless Fetch All Banks API",
                      "attempts": "1",
                      "moduleId": "module_opFamI_bav_verificationV4_module_fetchAll_banks_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "count": 0,
                              "bankList": [],
                              "popularBanks": [
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/SBIN.NS.svg",
                                      "name": "State Bank of India"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/HDFC.svg",
                                      "name": "HDFC Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IBN.svg",
                                      "name": "ICICI Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/AXISBANK.BO.svg",
                                      "name": "Axis Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/PNB.NS.svg",
                                      "name": "Punjab National Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/BANKBARODA.NS.svg",
                                      "name": "Bank of Baroda"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/KOTAKBANK.NS.svg",
                                      "name": "Kotak Mahindra Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/YESBANK.NS.svg",
                                      "name": "Yes Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/INDUSINDBK.NS.svg",
                                      "name": "Indusind Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/CANBK.NS.svg",
                                      "name": "Canara Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/UNIONBANK.NS.svg",
                                      "name": "Union Bank of India"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IDFCFIRSTB.NS.svg",
                                      "name": "IDFC FIRST Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/FEDERALBNK.NS.svg",
                                      "name": "Federal Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/RBLBANK.NS.svg",
                                      "name": "RBL Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/PSB.NS.svg",
                                      "name": "Punjab & Sind Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/INDIANB.NS.svg",
                                      "name": "Indian Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/CENTRALBK.NS.svg",
                                      "name": "Central Bank of India"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/UCO.svg",
                                      "name": "UCO Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/MAHABANK.NS.svg",
                                      "name": "Bank of Maharashtra"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IOB.NS.svg",
                                      "name": "Indian Overseas Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IDBI.NS.svg",
                                      "name": "IDBI"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/BANDHANBNK.NS.svg",
                                      "name": "Bandhan Bank"
                                  }
                              ]
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "1754046708502-36e7f14d-b4d3-4646-a641-2fd2fe3a575f",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:11:49.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Pennyless Search IFSC API",
                      "attempts": "5",
                      "moduleId": "module_opFamI_bav_verificationV4_module_search_ifsc_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "count": 10,
                              "IFSCList": [
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0944600",
                                      "city": "Noida",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Uttar Pradesh",
                                      "branch": "Sector Noida",
                                      "address": "Pnb Shop No Gf 45b 45c And Gf 46d Spectrum Metro",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0914600",
                                      "city": "Muzaffarnagar",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Uttar Pradesh",
                                      "branch": "Rapc Muzaffarnagar",
                                      "address": "Punjab National Bank Opp Saharanpur Bus Stand Rurkee Road Muzaffarnagar",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0934600",
                                      "city": "Noida",
                                      "imps": "true",
                                      "micr": "110024338",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Uttar Pradesh",
                                      "branch": "Sec Noida",
                                      "address": "Pnb 1 St Floor Tulip Mall Sec 48 Noida Uttarpradesh 201301",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0940600",
                                      "city": "Bongaigaon",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Assam",
                                      "branch": "Digital Banking Unit Kamrup",
                                      "address": "Bo Eobc Bangaigaon, Near Lower Assam Hospital Block 165 As Bonga 783380",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0944400",
                                      "city": "Coimbatore",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Tamil Nadu",
                                      "branch": "Sulur",
                                      "address": "3/130 D Trichy Road, Near Sulur Aero, Kangayampalayam Post, Sulur Tn Coimb 641401",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0944800",
                                      "city": "Mawkyrwat",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Meghalaya",
                                      "branch": "Mawkyrwat",
                                      "address": "Co Jason Medical Store Mawkyrwat South West Khasi Hills Me Mawky 793114",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0344600",
                                      "city": "Malout, Punjab",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Punjab",
                                      "branch": "Malout Loha Bazar, Distt. Fari",
                                      "address": "Loha Bazar Malout",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0644600",
                                      "city": "Muzaffar Nagar",
                                      "imps": "true",
                                      "micr": "251024545",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Uttar Pradesh",
                                      "branch": "Shahpur (muzaffarnagar) Up",
                                      "address": "Near Dr. Guptas",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0744600",
                                      "city": "Dehradun",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Uttarakhand",
                                      "branch": "Mehuwala Dehradun",
                                      "address": "Pnb Mehuwala",
                                      "swiftCode": ""
                                  },
                                  {
                                      "upi": "true",
                                      "IFSC": "PUNB0924600",
                                      "city": "Ghazipur",
                                      "imps": "true",
                                      "micr": "",
                                      "name": "Punjab National Bank",
                                      "neft": "true",
                                      "rtgs": "true",
                                      "state": "Uttar Pradesh",
                                      "branch": "Sekhanpur Ghazipur",
                                      "address": "Pnb Sekhanpur Block Ka Simabad",
                                      "swiftCode": ""
                                  }
                              ]
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "1754046752245-7cc01ebd-5711-4a6a-9bca-31d021a56e6e",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:12:33.000Z",
                      "previousAttempts": [
                          {
                              "module": "Pennyless Search IFSC API",
                              "attempts": "1",
                              "moduleId": "module_opFamI_bav_verificationV4_module_search_ifsc_genericApiV1",
                              "apiResponse": {
                                  "result": {
                                      "count": 10,
                                      "IFSCList": [
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0063400",
                                              "city": "Dhianpur (distt-gurdaspur)",
                                              "imps": "true",
                                              "micr": "143024254",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Dhianpur, Distt. Gurdaspur (pu",
                                              "address": "Dhianpur, Distt. Gurdaspur (pu",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0077300",
                                              "city": "Mehatpur",
                                              "imps": "true",
                                              "micr": "144024256",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Mehatpur, Distt. Jalandhar (pu",
                                              "address": "Mehatpur,punjab",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0348200",
                                              "city": "Dorangla (distt Gurdaspur)",
                                              "imps": "true",
                                              "micr": "143024257",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Dorangla, Distt. Gurdaspur (pu",
                                              "address": "Dorangla, Distt. Gurdaspur (pun)",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0065200",
                                              "city": "Fatehabad (distt-tarn Taran)",
                                              "imps": "true",
                                              "micr": "143024403",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Fatehabad, Distt. Amritsar (pu",
                                              "address": "Fatehabad Distt-tarn Taran (pb)",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0080100",
                                              "city": "Nurmahal,distt Jalandhar (punjab)",
                                              "imps": "true",
                                              "micr": "144024602",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Nurmahal, Distt. Jalandhar (pu",
                                              "address": "Nurmahal, Distt Jalandhar",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0330900",
                                              "city": "Thikriwala",
                                              "imps": "true",
                                              "micr": "148024453",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Thikriwala, Distt. Sengrur (pu",
                                              "address": "Vill And Po Thikriwala",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0124700",
                                              "city": "Balluana, Dist Ferozepur",
                                              "imps": "true",
                                              "micr": "152024352",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Balluana, Distt. Ferozepur (pu",
                                              "address": "Vill And Distt Balluana",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0126500",
                                              "city": "Binpalke (bhogpur)punjab",
                                              "imps": "true",
                                              "micr": "144024876",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Binpalke, Distt. Jalandhar (pu",
                                              "address": "Binpalke (bhogpur)",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0071100",
                                              "city": "Jaintipur",
                                              "imps": "true",
                                              "micr": "143024038",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Jaintipur, Distt. Amritsar (pu",
                                              "address": "Jaintipur",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0290600",
                                              "city": "Panjkosi (distt-firozepur)",
                                              "imps": "true",
                                              "micr": "152024356",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Panjkosi, Distt. Ferozepur (pu",
                                              "address": "Vill & Po:panjkosi",
                                              "swiftCode": ""
                                          }
                                      ]
                                  },
                                  "status": "success",
                                  "metaData": {
                                      "requestId": "1754046737918-243baf11-f7d5-449d-aa51-be4c1ade9e39",
                                      "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                                  },
                                  "statusCode": 200
                              },
                              "processedAt": "2025-08-01T11:12:19.000Z"
                          },
                          {
                              "module": "Pennyless Search IFSC API",
                              "attempts": "2",
                              "moduleId": "module_opFamI_bav_verificationV4_module_search_ifsc_genericApiV1",
                              "apiResponse": {
                                  "result": {
                                      "count": 10,
                                      "IFSCList": [
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0931000",
                                              "city": "Pune",
                                              "imps": "true",
                                              "micr": "411024032",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Baner Pune",
                                              "address": "Pnb 20 Sneh Park Housing Society New Pan Card Club Road Dhankude Vasti Baner Pune Mh Pune 411045",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0876200",
                                              "city": "Pune",
                                              "imps": "true",
                                              "micr": "411024030",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Armb Pune",
                                              "address": "Armb 9 Moldedina Road Aurora Towers Pune Mh Pune 411001",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0590800",
                                              "city": "Pune",
                                              "imps": "true",
                                              "micr": "411024026",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Wakad Pune",
                                              "address": "Amora House St 207 1 Kaspate Wasti Wakad Pune Mh Pune 411057",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0021810",
                                              "city": "Pimpri",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Pimpri-pune",
                                              "address": "Jhamtani Chambers 1stflr,mumbai-pune Rod 411018",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0014110",
                                              "city": "Pune",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Pune Main",
                                              "address": "Dinshaw House, 918, Synagouge Street, Pune 411001",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0221810",
                                              "city": "Pune",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Kharadi, Pune",
                                              "address": "A-1/2, Cheryl, Down Town, Pune - 411014",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0913300",
                                              "city": "Shirur",
                                              "imps": "true",
                                              "micr": "412024501",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Shirur Pune",
                                              "address": "Sno 1025 65b Gawali Bldg Pune Nagar Road Mh Shiru 412210",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0006200",
                                              "city": "Mumbai",
                                              "imps": "true",
                                              "micr": "400024016",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Mumbai Pnb House",
                                              "address": "Pnb House,",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0123400",
                                              "city": "Muktsar",
                                              "imps": "true",
                                              "micr": "152024452",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Bhagsar, Distt. Muktsar (punj",
                                              "address": "Bhagsar, Distt. Muktsar (punj",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0931200",
                                              "city": "Rampur",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Bihar",
                                              "branch": "Pnb Rampur",
                                              "address": "Pnb Rampur,po - Rampur P.s. Suryagarha Dist. - Lakhisarai Bh Lakhs 811310",
                                              "swiftCode": ""
                                          }
                                      ]
                                  },
                                  "status": "success",
                                  "metaData": {
                                      "requestId": "1754046741365-8e2a8811-5f7d-4f3d-9bf7-ec6f5b371b6a",
                                      "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                                  },
                                  "statusCode": 200
                              },
                              "processedAt": "2025-08-01T11:12:22.000Z"
                          },
                          {
                              "module": "Pennyless Search IFSC API",
                              "attempts": "3",
                              "moduleId": "module_opFamI_bav_verificationV4_module_search_ifsc_genericApiV1",
                              "apiResponse": {
                                  "result": {
                                      "count": 10,
                                      "IFSCList": [
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000130",
                                              "city": "Udaipur",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Rajasthan",
                                              "branch": "Shobhagpura",
                                              "address": "Plot Number Near J K Paras Hospital 3 Circle Shobhagpura",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000200",
                                              "city": "Abu Road",
                                              "imps": "true",
                                              "micr": "307024025",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Rajasthan",
                                              "branch": "Abu Road, Distt. Sirohi (rajas",
                                              "address": "Bank Street Abu Road",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000310",
                                              "city": "Kolkata",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "West Bengal",
                                              "branch": "Kolkata-brabourne Road",
                                              "address": "25,brabourne Road Thapar House 700001",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000410",
                                              "city": "Ludhiana",
                                              "imps": "true",
                                              "micr": "141024067",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Ludhianachaura Bazar",
                                              "address": "Chaura Bazar 141008",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000430",
                                              "city": "Kangra",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Himachal Pradesh",
                                              "branch": "Shivnagar",
                                              "address": "Vill Shivnagar Po Lahat Tehsil Jaisinghpur Distt Kangra",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000710",
                                              "city": "New Delhi",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Delhi",
                                              "branch": "New Delhi-e Block Connaught Place",
                                              "address": "E Block, Harsha Bhavan Connaught Place 110001",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000810",
                                              "city": "Delhi",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Delhi",
                                              "branch": "Delhi-naya Bazar",
                                              "address": "Thapar Building Naya Bazar 110006",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0000910",
                                              "city": "Patiala",
                                              "imps": "true",
                                              "micr": "147024024",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Punjab",
                                              "branch": "Patialaa Tank",
                                              "address": "A-tank Adalat Bazar 147001",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0001310",
                                              "city": "New Delhi",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Delhi",
                                              "branch": "Delhi-darya Ganj",
                                              "address": "Netaji Subhash Marg Daryaganj 110002",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0001320",
                                              "city": "Tinsukia",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Assam",
                                              "branch": "Tinsukia",
                                              "address": "Chiwara Patty,tinsukia",
                                              "swiftCode": ""
                                          }
                                      ]
                                  },
                                  "status": "success",
                                  "metaData": {
                                      "requestId": "1754046744311-7ee07c15-2fa0-431d-a894-3f792af90faa",
                                      "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                                  },
                                  "statusCode": 200
                              },
                              "processedAt": "2025-08-01T11:12:25.000Z"
                          },
                          {
                              "module": "Pennyless Search IFSC API",
                              "attempts": "4",
                              "moduleId": "module_opFamI_bav_verificationV4_module_search_ifsc_genericApiV1",
                              "apiResponse": {
                                  "result": {
                                      "count": 10,
                                      "IFSCList": [
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944400",
                                              "city": "Coimbatore",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Tamil Nadu",
                                              "branch": "Sulur",
                                              "address": "3/130 D Trichy Road, Near Sulur Aero, Kangayampalayam Post, Sulur Tn Coimb 641401",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944600",
                                              "city": "Noida",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Uttar Pradesh",
                                              "branch": "Sector Noida",
                                              "address": "Pnb Shop No Gf 45b 45c And Gf 46d Spectrum Metro",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944800",
                                              "city": "Mawkyrwat",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Meghalaya",
                                              "branch": "Mawkyrwat",
                                              "address": "Co Jason Medical Store Mawkyrwat South West Khasi Hills Me Mawky 793114",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944000",
                                              "city": "Gadchiroli",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Maharashtra",
                                              "branch": "Gadchiroli",
                                              "address": "Ground Floor Ridaan Complex Beside Ramayan Hotel Mh Gadch 442605",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944500",
                                              "city": "Vikarabad",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Telangana",
                                              "branch": "Vikarabad",
                                              "address": "Municipal No.4-1-251/1 New Ganj Tl Vikar 501101",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944100",
                                              "city": "Kalol",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Gujarat",
                                              "branch": "Kalol",
                                              "address": "Pnb Kalol R C Patel Etate Derol Road Kalol Gj Kalol 389330",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944300",
                                              "city": "Mahuva",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Gujarat",
                                              "branch": "Mahuva",
                                              "address": "Pnb Opp New Hosuing Board Vt Nagar Road Gujarat",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944700",
                                              "city": "Baran",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Rajasthan",
                                              "branch": "Kishanganj",
                                              "address": "Pnb Kashra No 1781/453 Opposite Tehsil Office Rj Baran 325216",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944200",
                                              "city": "Tandur",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Telangana",
                                              "branch": "Tandur",
                                              "address": "Dno 2-2-216, Shailaja Complex Kodangal Road Tl Tandu 501141",
                                              "swiftCode": ""
                                          },
                                          {
                                              "upi": "true",
                                              "IFSC": "PUNB0944900",
                                              "city": "Muzaffarpur",
                                              "imps": "true",
                                              "micr": "",
                                              "name": "Punjab National Bank",
                                              "neft": "true",
                                              "rtgs": "true",
                                              "state": "Bihar",
                                              "branch": "Zero Mile Muzaffarpur",
                                              "address": "Yamuna Complex, Akharaghat Road Shekhpura, Muzaffarpur Bh Muzaf 842002",
                                              "swiftCode": ""
                                          }
                                      ]
                                  },
                                  "status": "success",
                                  "metaData": {
                                      "requestId": "1754046747875-41360314-b07c-489b-95f4-8d99ad703f6c",
                                      "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                                  },
                                  "statusCode": 200
                              },
                              "processedAt": "2025-08-01T11:12:29.000Z"
                          }
                      ]
                  },
                  {
                      "module": "Pennyless Search Banks API",
                      "attempts": "1",
                      "moduleId": "module_opFamI_bav_verificationV4_module_search_banks_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "count": 0,
                              "bankList": [],
                              "popularBanks": [
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/SBIN.NS.svg",
                                      "name": "State Bank of India"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/HDFC.svg",
                                      "name": "HDFC Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IBN.svg",
                                      "name": "ICICI Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/AXISBANK.BO.svg",
                                      "name": "Axis Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/PNB.NS.svg",
                                      "name": "Punjab National Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/BANKBARODA.NS.svg",
                                      "name": "Bank of Baroda"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/KOTAKBANK.NS.svg",
                                      "name": "Kotak Mahindra Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/YESBANK.NS.svg",
                                      "name": "Yes Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/INDUSINDBK.NS.svg",
                                      "name": "Indusind Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/CANBK.NS.svg",
                                      "name": "Canara Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/UNIONBANK.NS.svg",
                                      "name": "Union Bank of India"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IDFCFIRSTB.NS.svg",
                                      "name": "IDFC FIRST Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/FEDERALBNK.NS.svg",
                                      "name": "Federal Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/RBLBANK.NS.svg",
                                      "name": "RBL Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/PSB.NS.svg",
                                      "name": "Punjab & Sind Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/INDIANB.NS.svg",
                                      "name": "Indian Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/CENTRALBK.NS.svg",
                                      "name": "Central Bank of India"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/UCO.svg",
                                      "name": "UCO Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/MAHABANK.NS.svg",
                                      "name": "Bank of Maharashtra"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IOB.NS.svg",
                                      "name": "Indian Overseas Bank"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/IDBI.NS.svg",
                                      "name": "IDBI"
                                  },
                                  {
                                      "logo": "https://ifsc-bank-logos.s3.ap-south-1.amazonaws.com/popularBankLogos/svg/BANDHANBNK.NS.svg",
                                      "name": "Bandhan Bank"
                                  }
                              ]
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "1754046780540-31a1c68c-9511-4e18-ad1b-387f78af0a4f",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:13:01.000Z",
                      "previousAttempts": []
                  },
                  {
                      "module": "Pennyless API",
                      "attempts": "1",
                      "moduleId": "module_opFamI_bav_verificationV4_module_pennyless_genericApiV1",
                      "apiResponse": {
                          "result": {
                              "message": "Bank Account details verified successfully.",
                              "accountName": "DIPTI KUMARI",
                              "accountExists": true,
                              "isOverseasAccount": "No"
                          },
                          "status": "success",
                          "metaData": {
                              "requestId": "1754046780482-ac1aa74c-a65b-4392-b61d-6635fb8e3464",
                              "transactionId": "ab937578-6553-4c46-8148-553869e1d88f"
                          },
                          "statusCode": 200
                      },
                      "processedAt": "2025-08-01T11:13:04.000Z",
                      "previousAttempts": []
                  }
              ],
              "flagsFound": [
                  {
                      "flags": {
                          "503": "Source Unavailable"
                      },
                      "module": "module_LYqrsv_genericApiV1"
                  }
              ],
              "userDetails": {
                  "CIN_value": "U67100GJ2022PTC133462",
                  "DIN_value": "10118876",
                  "BAV_Status": "success",
                  "CIN_API_status": "success",
                  "GSTIN_API_status": "success",
                  "GeoIP_IP_Address": "203.145.56.249",
                  "Field_Match_Action": true,
                  "CIN_API_companyName": "EOPSIN TECH PRIVATE LIMITED",
                  "GSTIN_API_legalName": "EOPSIN TECH PRIVATE LIMITED",
                  "Digilocker_StatusCode": "200",
                  "Selfie_Validation_Action": "pass",
                  "POA_Capture_Action_-_Back": "",
                  "POA_Capture_Action_-_Front": "",
                  "Digilocker_MaskedAadhaarNumber": "xxxxxxxx4317",
                  "Individual_PAN_DB_Check_Action": "pass",
                  "Name_Match:_GSTIN_and_CIN_Action": "pass",
                  "Face_Match:_POA_and_Selfie_Action": "",
                  "Fetch_Director_Details_API_status": "success",
                  "GSTIN_form_Enter_GSTIN_Here_value": "09AAHCE1231H1ZW",
                  "POA_DB_Check_(not_Aadhaar)_Action": "",
                  "Company_PAN_Capture_Action_-_Front": "",
                  "Company_PAN_Capture_ID_Number_-_Front": "",
                  "Fetch_Company_Info_From_PAN_API_status": "",
                  "Field_Match:_GSTIN_and_PAN_Name_Action": "",
                  "Fetch_Director_Details_API_directorName": "DIPTI KUMARI",
                  "Face_Match:_Digilocker_and_Selfie_Action": "pass",
                  "PAN_Capture_for_Individual_Action_-_Front": "pass",
                  "Fetch_Company_Info_From_PAN_API_companyName": "",
                  "Company_Type_Selection_Type_of_Company_value": "ppl"
              },
              "workflowDetails": {
                  "version": 1,
                  "workflowId": "E7EkTB_18_06_25_14_57_13"
              },
              "applicationStatus": "auto_approved"
          },
          "created_at": "2025-08-01T11:13:58.555Z",
          "updated_at": "2025-08-01T11:13:58.555Z"
      }
  ]
}